module.exports = __webpack_public_path__ + "media/images/flags/si-f15d5901ccf9ff467b96ebfea08ff80d.svg";